"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.NotesSidebar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var classnames_1 = __importDefault(require("classnames"));
var conditional_1 = require("../conditional/conditional");
var DEFAULT_PROPS = {
    documentMetadata: [],
    grouped: false,
    onSelect: function (docMetadata) { }
};
var DocCategories = {
    DFT: 'DFTs',
    DFT_IN: 'Inbound DFTs',
    DFT_OUT: 'Outbound DFTs',
    NTE: 'Notes',
    NOTE: 'Notes',
    HL7: 'HL7 Messages',
    DFT_EHR: 'DFT EHRs'
};
var NotesSidebar = function (passed) {
    var props = __assign(__assign({}, DEFAULT_PROPS), passed);
    var documentMetadata = props.documentMetadata, onSelect = props.onSelect, activeNote = props.activeNote, isIPC = props.isIPC, capabilities = props.capabilities, grouped = props.grouped;
    //@ts-ignore
    var prepped = (documentMetadata || []).map(function (doc) {
        // Document categories are not named for end users.
        // Supplant with our own category names, shown above.
        // But if someone adds a document category we don't want to
        // blow up.
        if (doc.mimeType === 'text/html') {
            doc.documentCategory = 'HTML';
        }
        return __assign(__assign({}, doc), { documentCategory: DocCategories[doc.documentCategory] || doc.documentCategory });
    });
    var preppedDocs;
    if (grouped) {
        var sortGroupedDocs = function (a, b) {
            if (a === b)
                return 0;
            if (a === 'HL7 Messages' || a === 'Notes')
                return -1;
            if (b === 'HL7 Messages' || b === 'Notes')
                return 1;
            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        };
        preppedDocs = ui_common_1.objectUtils.groupBy(prepped, 'documentCategory');
        Object.keys(preppedDocs).sort(sortGroupedDocs);
    }
    else {
        preppedDocs = prepped;
    }
    var buildDocList = function (docs) {
        return docs.map(function (document, idx) {
            var _a;
            var onClick = function (event) {
                event.preventDefault();
                onSelect(document);
            };
            var isActive = (activeNote === null || activeNote === void 0 ? void 0 : activeNote.id) === document.id;
            var styleClasses = (0, classnames_1["default"])([
                { 'is-active': isActive },
                'sidebar-link'
            ]);
            return ((0, jsx_runtime_1.jsx)("li", __assign({ className: styleClasses }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: "#/something", onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "document-name" }, { children: (_a = document.documentName) !== null && _a !== void 0 ? _a : 'Name N/A' })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "document-description" }, { children: document.documentDescription })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "document-status" }, { children: document.documentStatus }))] })) }), document.documentGuid.uuid));
        });
    };
    var content;
    if (grouped) {
        content = Object.keys(preppedDocs).map(function (key) {
            var docs = preppedDocs[key];
            var items = buildDocList(preppedDocs[key]);
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "note-doc-category", style: { display: 'none' } }, { children: docs[0].documentCategory })), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "note-sidebar-list" }, { children: items }))] }, key));
        });
    }
    else {
        content = ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("ul", __assign({ className: "note-sidebar-list" }, { children: buildDocList(preppedDocs) })), ' '] }));
    }
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "notes-sidebar" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "sidebar-fixed" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "sidebar-container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "sidebar-inner" }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [(documentMetadata === null || documentMetadata === void 0 ? void 0 : documentMetadata.length) > 1] }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: content }) })), props.children] })) })) })) })));
};
exports.NotesSidebar = NotesSidebar;
//# sourceMappingURL=notes-sidebar.js.map